import React, { useRef, useEffect, useState  } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../AuthProvider";


import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Box,
  Button,
  Card,FormControlLabel,
  CardContent,
  Typography,
  TextField,
  InputAdornment ,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,Checkbox,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  Grid,
  ListItemIcon,
  ListItemText,DialogActions,DialogContent,DialogTitle,Dialog,Divider
} from "@mui/material";

import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';


const baseUrl = process.env.REACT_APP_API_BASE_URL

export default function OverAllReports() {

   const { oId ,board,pId} = useAuth();
    const [studentData, setStudentData] = useState([]);
  const todayDate = new Date().toISOString().slice(0, 10);
  const today = new Date();
  const [viewType, setViewType] = useState("daily"); // "daily" or "monthly"
  const [selectedDate, setSelectedDate] = useState(today.toISOString().slice(0, 10));
  console.log("selected date:",selectedDate);
  const [selectedMonth, setSelectedMonth] = useState(`${today.getMonth() + 1}`);
  const [selectedYear, setSelectedYear] = useState(`${today.getFullYear()}`);
  const tableRef = useRef(null);

  const [formData, setFormData] = useState({ todayDepositAmount: "" });
  const [expenseName, setExpenseName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // const [showDepositForm, setShowDepositForm] = useState(true);


   const [sampleRows, setSampleRows] = useState([]);
  const [loader, setLoader] = useState(false);
// const [deposits, setDeposits] = useState({});
const [isUserEdited, setIsUserEdited] = useState(false);

const [cashSummary, setCashSummary] = useState({
  totalExpenseCash: 0,
  totalTransactionCash: 0,
  availableInHandCash: 0,
});
 
 
   const [companyInfo, setCompanyInfo] = useState({});

const capitalizeWords = (str) =>
  str
    ? str.replace(/\b\w/g, (char) => char.toUpperCase()) // capitalize letter after word boundary
    : "";


   
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

    const [openDialog, setOpenDialog] = useState(false);

      const handleExportClickd = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosed = () => {
    setAnchorEl(null);
  };

  const handleExportClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);


    const [totals, setTotals] = useState({
    openingBalance: 0,
    todayCollectedAmount: 0,
    totalAmount: 0,
    todayDepositAmount: 0,
    expenseAmount: 0,
    closingBalance: 0,

    totalCollected: 0,
    totalExpenses: 0,
    totalDeposits: 0,
    closingBalance: 0,
    totalAmountOfMonth: 0,
  });


  // 🧠 State
const [deposits, setDeposits] = useState({
  todayDepositAmount: 0,
  isEditing: false,
  editAmount: "",
});



  const months = ["Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


   const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {

    fetchUsers();

}, []); // ✅ Only runs on mount
 
   
  //organization details api
      useEffect(() => {
        const fetchCompanyInfo = async () => {
          try {
            const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
           
   
            const data = await response.json();
            setCompanyInfo({
              schoolLogo: data.schoolLogo,
              schoolStamp:data.schoolStamp,
              schoolName: data.schoolName,
              city: data.city,
              state: data.state,
              affiliationNumber: data.affiliationNumber,
              schoolAddress: data.schoolAddress,
              primaryContact: data.primaryContact,
              boardAffiliation: data.boardAffiliation,
              secondaryContact: data.secondaryContact,
              pincode: data.pincode,
              schoolEmailId: data.schoolEmailId,
            });
            // setTempInfo(data);
   
            // setOrgLoading(false); // Data fetched, stop loading
   
          } catch (error) {
            console.error("Error fetching company info:", error);
            // setOrgLoading(false); // Stop loading even if there's an error
          }
        };
   
        fetchCompanyInfo();
      }, []);
 


  // ✅ Fetch daily balance summary
  // const fetchDailySummary = async () => {
  //   if(!selectedDate) return;
  //   try {
  //     setLoader(true);
  //     const res = await fetch(`${baseUrl}/api/balanceReport/getSummary/${pId}/${selectedDate}`);
  //     if (!res.ok) throw new Error("Failed to fetch daily summary");
  //     const data = await res.json();
  //     setTotals(data);

  //     // ✅ set deposit as a single object
  //   setDeposits({
  //     todayDepositAmount: data.todayDepositAmount || 0,
  //     isEditing: false,
  //     editAmount: "",
  //   });

  //   } catch (err) {
  //     console.error("Error fetching daily summary:", err);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const fetchDailySummary = async () => {
  if (!selectedDate) return;
  try {
    setLoader(true);
    const res = await fetch(`${baseUrl}/api/balanceReport/getSummary/${pId}/${selectedDate}`);
    if (!res.ok) throw new Error("Failed to fetch daily summary");
    const data = await res.json();
    setTotals(data);
    setDeposits({
      todayDepositAmount: data.todayDepositAmount || 0,
      isEditing: false,
      editAmount: "",
    });

    setViewType("daily"); // ✅ set view type
  } catch (err) {
    console.error("Error fetching daily summary:", err);
  } finally {
    setLoader(false);
  }
};


  // ✅ Fetch monthly balance summary
  // const fetchMonthlySummary = async (monthIndex, year) => {
  //   try {
  //     setLoader(true);
  //     const monthName = months[monthIndex];
  //     const res = await fetch(
  //       `${baseUrl}/api/balanceReport/getSummaryTotalMonthly/${pId}/${monthName}/${year}`
  //     );
  //     if (!res.ok) throw new Error("Failed to fetch monthly summary");
  //     const data = await res.json();
  //     setTotals(data);
  //   } catch (err) {
  //     console.error("Error fetching monthly summary:", err);
  //   } finally {
  //     setLoader(false);
  //   }
  // };
  const fetchMonthlySummary = async (monthIndex, year) => {
  try {
    setLoader(true);
    const monthName = months[monthIndex];
    const res = await fetch(
      `${baseUrl}/api/balanceReport/getSummaryTotalMonthly/${pId}/${monthName}/${year}`
    );
    if (!res.ok) throw new Error("Failed to fetch monthly summary");
    const data = await res.json();
    setTotals(data);

    setViewType("monthly"); // ✅ set view type
  } catch (err) {
    console.error("Error fetching monthly summary:", err);
  } finally {
    setLoader(false);
  }
};


  // ✅ Fetch when inputs change
  useEffect(() => {
    if (viewType === "daily" && selectedDate) {
      fetchDailySummary();
    } else if (viewType === "monthly" && selectedMonth && selectedYear) {
      fetchMonthlySummary(selectedMonth, selectedYear);
    }
  }, [viewType, selectedDate, selectedMonth, selectedYear]);




 
// 🧭 Fetch TABLE data when date, viewType, or selectedUsers changes
useEffect(() => {
  if (viewType === "daily" ) {
    fetchSampleRows(selectedDate);
  }
}, [viewType, selectedDate]);

// ✅ Fetch Sample Rows
const fetchSampleRows = async (date) => {
  try {
    setLoader(true);

    const feeType = "tution_fee";

    const response = await fetch(
      `${baseUrl}/api/balanceReport/adm/getCustomTransactionAll/${date}/${oId}`
    );        

    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();

    // ✅ Store raw data
    setSampleRows(data);
  } catch (error) {
    console.error("Error fetching data:", error);
    setSampleRows([]);
  } finally {
    setLoader(false);
  }
};


const fetchCashSummary = async () => {
  try {
    if (!selectedDate) return;

    const response = await fetch(`${baseUrl}/api/balanceReport/cash-DepositSummary/${pId}/${selectedDate}`);
    if (!response.ok) {
      throw new Error('Failed to fetch cash summary');
    }
    const data = await response.json();
    setCashSummary(data);
  } catch (error) {
    console.error('Error fetching cash summary:', error);
  }
};

useEffect(() => {
  fetchCashSummary();
}, [selectedDate]);





//POST METHOD
// const handleSave = async () => {
//   let newErrors = {};

//   // Only show red border (no text)
//   if (!formData.todayDepositAmount || Number(formData.todayDepositAmount) <= 0) {
//     newErrors.todayDepositAmount = true;
//   }

//   setErrors(newErrors);
//   if (Object.keys(newErrors).length > 0) return;

//   setLoading(true);

//   try {
//     // const today = new Date().toISOString().split("T")[0];

//     const response = await fetch(
//       `${baseUrl}/api/balanceReport/calculate/${pId}?depositAmount=${Number(
//         formData.todayDepositAmount
//       )}&date=${selectedDate}`,
//       { method: "POST" }
//     );

//     if (response.ok) {
//       toast.success("Today's deposit amount saved successfully!", {
//         position: "top-right",
//         autoClose: 1000,
//       });

//       // ✅ Clear input
//       setFormData({ todayDepositAmount: "" });
//        setShowDepositForm(false); 
//       setOpenDialog(false);
//       fetchDailySummary();
//     } else {
//       const errorText = await response.text();
//       toast.error(`Failed to save: ${errorText || "Something went wrong"}`, {
//         position: "top-right",
//         autoClose: 1000,
//       });
//     }
//   } catch (err) {
//     console.error(err);
//     toast.error("An error occurred while saving deposit amount", {
//       position: "top-right",
//       autoClose: 1000,
//     });
//   } finally {
//     setLoading(false);
//   }
// };

const handleSave = async () => {
  let newErrors = {};

 
  const finalAmount = isUserEdited
    ? formData.todayDepositAmount
    : cashSummary?.availableInHandCash?.toString() || "";

 
  if (!finalAmount || Number(finalAmount) <= 0) {
    newErrors.todayDepositAmount = true;
  }

  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) return;

  setLoading(true);

  try {
    const response = await fetch(
      `${baseUrl}/api/balanceReport/calculate/${pId}?depositAmount=${Number(
        finalAmount
      )}&date=${selectedDate}`,
      { method: "POST" }
    );

    if (response.ok) {
      toast.success("Today's deposit amount saved successfully!", {
        position: "top-right",
        autoClose: 1000,
      });

     
      setFormData({ todayDepositAmount: "" });
      // setShowDepositForm(false);
      setOpenDialog(false);
      fetchDailySummary();
    } else {
      const errorText = await response.text();
      toast.error(`Failed to save: ${errorText || "Something went wrong"}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  } catch (err) {
    console.error(err);
    toast.error("An error occurred while saving deposit amount", {
      position: "top-right",
      autoClose: 1000,
    });
  } finally {
    setLoading(false);
  }
};



 // ✅ Set default value when dialog opens or totals change (but only if user hasn’t edited)
useEffect(() => {
    if (open && totals?.todayTransactionCash !== undefined) {
      setFormData((prev) => ({
        ...prev,
        todayDepositAmount:
          !isUserEdited && (!prev.todayDepositAmount || prev.todayDepositAmount === "")
            ? totals.todayTransactionCash?.toString() || "0"
            : prev.todayDepositAmount,
      }));
      setErrors((prev) => ({ ...prev, todayDepositAmount: "" }));
    }

    // Reset user edit flag when dialog closes
    if (!open) setIsUserEdited(false);
  }, [open, totals?.todayTransactionCash]);



const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  // const ws = workbook.addWorksheet(`Fee Summary Report_${selectedDate}`);
  let ws = null;

   // 🗓 Convert numeric month to short month name (e.g., 10 → Oct)
  const getMonthName = (monthNumber) => {
    const date = new Date(2000, monthNumber - 1); // monthNumber is 1-based
    return date.toLocaleString("en-US", { month: "short" }); // "Jan", "Feb", "Mar", etc.
  };

  const monthName = getMonthName(selectedMonth);

  if (viewType === "daily") {
     ws = workbook.addWorksheet(`Fee Summary Report_${selectedDate}`);
  } else if (viewType === "monthly") {
     ws = workbook.addWorksheet(`Fee Summary Report_${monthName}_${selectedYear}`);
  } else {
    // fallback if needed
     ws = workbook.addWorksheet(`Fee Summary Report`);
  }






  // === Colors ===
  const primary = "FF00796B";
  const headerText = { argb: "FFFFFFFF" };
  const redText = { argb: "FFB71C1C" };
  const thinBorderColor = { argb: "FFcccccc" };

  const applyThinBorder = (cell) => {
    cell.border = {
      top: { style: "thin", color: thinBorderColor },
      left: { style: "thin", color: thinBorderColor },
      bottom: { style: "thin", color: thinBorderColor },
      right: { style: "thin", color: thinBorderColor },
    };
  };

  const styleHeaderCell = (cell, bg = primary, font = headerText, size = 11, bold = true) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
    cell.font = { bold, color: font, size };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    applyThinBorder(cell);
  };

  // === Layout Columns ===
  const colWidths = [6, 16, 28, 14, 22, 16, 16, 14, 16, 8, 8, 10, 12, 10];
  ws.columns = colWidths.map((w) => ({ width: w }));

 
 // === Top header (School Name) ===
ws.mergeCells("A1:L1");
const schoolCell = ws.getCell("A1");
schoolCell.value = (companyInfo.schoolName || "N/A").toUpperCase();
schoolCell.font = { size: 50, bold: true }; // 🔹 increased font size
schoolCell.alignment = { horizontal: "center", vertical: "middle" };
styleHeaderCell(schoolCell, primary);

ws.getRow(1).height = 20;

  // === Date Line ===
  ws.mergeCells("A3:L3");
  ws.getCell("A3").value = `GENERATED DATE: ${selectedDate}`;
  ws.getCell("A3").font = { size: 11, bold: true };
  ws.getCell("A3").alignment = { horizontal: "center", vertical: "middle" };
  styleHeaderCell(ws.getCell("A3"), primary);

  ws.addRow([]);

  // === Summary Items ===
const summaryItems =
  viewType === "daily"
    ? [
        { title: "OPENING BALANCE", value: totals.openingBalance || 0 },
        { title: "COLLECTED AMOUNT", value: totals.todayCollectedAmount || 0 },
        { title: "TOTAL AMOUNT(OPEN + COLLECTED - EXPENSE)", value: totals.totalAmount || 0 },
       
        { title: "DEPOSIT AMOUNT(ONLY CASH)", value: totals.todayDepositAmount || 0 },
         { title: "EXPENSE AMOUNT", value: totals.expenseAmount || 0 },
        { title: "CLOSING BALANCE(TOTAL - ONLINE - DEPOSIT)", value: totals.closingBalance || 0 },
      ]
    : [
        { title: "OPENING BALANCE", value: totals.openingBalance || 0 },
        { title: "COLLECTED AMOUNT", value: totals.totalCollected || 0 },
        { title: "TOTAL AMOUNT(OPEN + COLLECTED - EXPENSE)", value: totals.totalAmountOfMonth || 0 },
       
        { title: "DEPOSIT AMOUNT(ONLY CASH)", value: totals.totalDeposits || 0 },
         { title: "EXPENSE AMOUNT", value: totals.totalExpenses || 0 },
        { title: "CLOSING BALANCE(TOTAL - ONLINE- DEPOSIT)", value: totals.closingBalance || 0 },
      ];


  const summaryCols = [["A", "B"], ["C", "D"], ["E", "F"], ["G", "H"], ["I", "J"], ["K", "L"]];
// Increase column widths for long titles


ws.getColumn("C").width = 19;
ws.getColumn("D").width = 10;
ws.getColumn("E").width = 22;
ws.getColumn("F").width = 23;
ws.getColumn("G").width = 15;
ws.getColumn("H").width = 15;
ws.getColumn("I").width = 13;
ws.getColumn("K").width = 20;
ws.getColumn("L").width = 21;

  const summaryTitleRow = ws.addRow([]);
  const summaryValueRow = ws.addRow([]);

  summaryItems.forEach((item, idx) => {
    const [start, end] = summaryCols[idx];
    ws.mergeCells(`${start}${summaryTitleRow.number}:${end}${summaryTitleRow.number}`);
    const titleCell = ws.getCell(`${start}${summaryTitleRow.number}`);
    titleCell.value = item.title;
    styleHeaderCell(titleCell, primary);
    titleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: false };

    ws.mergeCells(`${start}${summaryValueRow.number}:${end}${summaryValueRow.number}`);
    const valueCell = ws.getCell(`${start}${summaryValueRow.number}`);
    valueCell.value = item.value;
    valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
    valueCell.font = { bold: true, color: redText };
    valueCell.alignment = { horizontal: "center", vertical: "middle", wrapText: false };
    applyThinBorder(valueCell);
    if (typeof item.value === "number")
      valueCell.numFmt = '"₹"#,##0.00;[Red]-"₹"#,##0.00';
  });

  ws.getRow(summaryTitleRow.number).height = 24;
  ws.getRow(summaryValueRow.number).height = 22;

  ws.addRow([]);

  
  // 🟩 ONLINE & CASH AMOUNT ROW
const onlineOfflineRow = ws.addRow([]);

// ✅ Define teal green background (same as header color)
const tealGreen = "FF00796B"; // Teal background
const whiteText = { argb: "FFFFFFFF" }; // White font color

// --- ONLINE AMOUNT LABEL ---
ws.mergeCells(`A${onlineOfflineRow.number}:C${onlineOfflineRow.number}`);
const onlineLabelCell = ws.getCell(`A${onlineOfflineRow.number}`);
onlineLabelCell.value = "ONLINE AMOUNT:";
onlineLabelCell.font = { bold: true, color: whiteText };
onlineLabelCell.alignment = { horizontal: "right", vertical: "middle" };
onlineLabelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tealGreen } };
applyThinBorder(onlineLabelCell);

// --- ONLINE AMOUNT VALUE ---
ws.mergeCells(`D${onlineOfflineRow.number}:F${onlineOfflineRow.number}`);
const onlineValueCell = ws.getCell(`D${onlineOfflineRow.number}`);
onlineValueCell.value = `₹${totals.todayTransactionOnline || 0}`;
onlineValueCell.font = { bold: true, color: whiteText };
onlineValueCell.alignment = { horizontal: "left", vertical: "middle" };
onlineValueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tealGreen } };
applyThinBorder(onlineValueCell);

// --- CASH AMOUNT LABEL ---
ws.mergeCells(`G${onlineOfflineRow.number}:I${onlineOfflineRow.number}`);
const cashLabelCell = ws.getCell(`G${onlineOfflineRow.number}`);
cashLabelCell.value = "CASH AMOUNT:";
cashLabelCell.font = { bold: true, color: whiteText };
cashLabelCell.alignment = { horizontal: "right", vertical: "middle" };
cashLabelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tealGreen } };
applyThinBorder(cashLabelCell);

// --- CASH AMOUNT VALUE ---
ws.mergeCells(`J${onlineOfflineRow.number}:L${onlineOfflineRow.number}`);
const cashValueCell = ws.getCell(`J${onlineOfflineRow.number}`);
cashValueCell.value = `₹${totals.todayTransactionCash || 0}`;
cashValueCell.font = { bold: true, color: whiteText };
cashValueCell.alignment = { horizontal: "left", vertical: "middle" };
cashValueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tealGreen } };
applyThinBorder(cashValueCell);

ws.getRow(onlineOfflineRow.number).height = 20;


    ws.addRow([]);

  // ✅ Only export main table for Daily view
if (viewType === "daily") {
  // === Main Table Headers ===
  const tableHeaders = [
    "S.NO",
    "ADMISSION NO",
    "STUDENT NAME",
    "CLASS",
    "FATHER NAME",
    "RECEIPT NO",
    "RECEIPT TYPE",
    "PAYMENT TYPE",
    "AMOUNT",
    "","",""
  ];
  const headerRow = ws.addRow(tableHeaders);
  headerRow.height = 26;
  headerRow.eachCell((cell) => styleHeaderCell(cell, primary));

  // === Data Rows ===
(sampleRows || []).forEach((r, i) => {
  const formattedPaymentType = r.paymentType
    ? r.paymentType
        .replace(/[^a-zA-Z0-9 ]/g, " ") // remove special characters and underscores
        .split(" ")                     // split into words
        .filter(Boolean)                // remove empty items
        .map(
          (word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // capitalize each word
        )
        .join(" ")                      // join back with spaces
    : "";

  const rowVals = [
    i + 1, // S.No
    r.admissionNumber || "", // Admission No
    `${r.firstName || ""} ${r.lastName || ""}`.trim(),
    r.romanNumberClass || "",
    r.fathersName || "N/A",
    r.receiptNo || "N/A",
    r.receiptType || "N/A",
    formattedPaymentType, // ✅ Cleaned & capitalized Payment Type
    r.totalPaid || 0, // Amount
  ];

  const row = ws.addRow(rowVals);

  row.eachCell((cell, col) => {
    // Center all cells vertically and horizontally
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: col !== 8 };

    // Apply thin border
    applyThinBorder(cell);

    // Format only Amount column (col 9)
    if (col === 9 && typeof cell.value === "number") {
      cell.numFmt = '"₹"#,##0.00;[Red]-"₹"#,##0.00';
    }
  });
});

// === Total Paid Amount Row ===
const totalPaid = (sampleRows || []).reduce((sum, r) => sum + (r.totalPaid || 0), 0);
const totalRow = ws.addRow([]);

// Merge A:H for label (till Payment Type column)
ws.mergeCells(`A${totalRow.number}:H${totalRow.number}`);
const totalCell = ws.getCell(`A${totalRow.number}`);
totalCell.value = "TOTAL PAID AMOUNT";
totalCell.font = { bold: true, size: 12, color: headerText };
totalCell.alignment = { horizontal: "center", vertical: "middle" };
styleHeaderCell(totalCell, primary);

// Put total only in Amount column (Column I)
const totalAmountCell = ws.getCell(`I${totalRow.number}`);
totalAmountCell.value = totalPaid;
totalAmountCell.numFmt = '"₹"#,##0.00;[Red]-"₹"#,##0.00';
totalAmountCell.font = { bold: true, color: headerText };
totalAmountCell.alignment = { horizontal: "center", vertical: "middle" };
styleHeaderCell(totalAmountCell, primary);

["J", "K", "L"].forEach((col) => {
  const cell = ws.getCell(`${col}${totalRow.number}`);
  styleHeaderCell(cell, primary);
});

// Apply borders to all columns A → L
for (let c = 1; c <= 12; c++) applyThinBorder(ws.getRow(totalRow.number).getCell(c));

}



  // === Save File ===
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
 

  if (viewType === "daily") {
     saveAs(blob, `Fee Summary Report_${selectedDate}.xlsx`);
  } else if (viewType === "monthly") {
    saveAs(blob, `Fee Summary Report_${monthName}_${selectedYear}.xlsx`);
  } else {
    // fallback if needed
    saveAs(blob, `Fee Summary Report.xlsx`);
  }
};

   // ✅ PDF Export Function
const exportToPDF = async () => {
  handleClose();
  const input = tableRef.current;

  // Initialize PDF
  const pdf = new jsPDF("p", "pt", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();   // ~595 pt
  const pdfHeight = pdf.internal.pageSize.getHeight(); // ~842 pt

  const margin = 40; // 🔹 margin on all sides (in pt)

  // Capture the table as a canvas
  const canvas = await html2canvas(input, {
    scale: 2,
    useCORS: true,
    logging: false,
  });

  const imgData = canvas.toDataURL("image/png");

  // Calculate image dimensions to fit within margins
  const availableWidth = pdfWidth - margin * 2;
  const availableHeight = pdfHeight - margin * 2;

  const imgProps = pdf.getImageProperties(imgData);
  const imgAspectRatio = imgProps.height / imgProps.width;

  let imgWidth = availableWidth;
  let imgHeight = availableWidth * imgAspectRatio;

  // If the image height exceeds available height, scale down proportionally
  if (imgHeight > availableHeight) {
    imgHeight = availableHeight;
    imgWidth = availableHeight / imgAspectRatio;
  }

  let positionY = margin;
  let positionX = (pdfWidth - imgWidth) / 2; // center horizontally

  // Add the first page
  pdf.addImage(imgData, "PNG", positionX, positionY, imgWidth, imgHeight);

  // If content is taller than one page → paginate
  let heightLeft = imgHeight - availableHeight;
  while (heightLeft > 0) {
    pdf.addPage();
    positionY = margin - heightLeft;
    pdf.addImage(imgData, "PNG", positionX, positionY, imgWidth, imgHeight);
    heightLeft -= availableHeight;
  }

  pdf.save(`OverAllReports_${selectedDate}.pdf`);
};


 

  return (
    <div style={{ margin:"3% 0% 0% 0%",padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "12px", boxShadow: "0 0 10px rgba(0,0,0,0.2)", overflow: "hidden" }}>
       <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#3C3972",
    color: "white",
    padding: "15px 20px",
  }}
>
  {/* Title */}
  <div style={{ fontSize: "18px", fontWeight: "bold" }}>Summary Report</div>

  {/* Controls */}
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
     {/* --------------------- Filter Section --------------------- */}
      <div >
        {/* View Switcher */}
        <select
          value={viewType}
          onChange={(e) => setViewType(e.target.value)}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid #3C3972",
            backgroundColor: "#fff",
            fontWeight: "bold",
            color: "#3C3972",
            marginRight:'10px'
          }}
        >
          <option value="daily">Daily</option>
          <option value="monthly">Monthly</option>
        </select>

        {/* Conditional Inputs */}
        {viewType === "daily" ? (
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
           max={new Date().toISOString().split("T")[0]} // ✅ correct way for native input
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
            }}
          />
        ) : (
          <>
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                marginRight:'10px'
              }}
            >
              {months.map((m, i) => (
                <option key={i} value={i}>
                  {m}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
              }}
            >
              {(() => {
                const y = today.getFullYear();
                return [y - 1, y].map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ));
              })()}
            </select>
          </>
        )}
      </div>

    {/* Add Deposit Button */}
    {/* ✅ Only show Expense column in Daily View */}
  {viewType === "daily" && (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => setOpenDialog(true)}
      sx={{
        backgroundColor: "#009688",
        color: "white",
        fontWeight: "bold",
        "&:hover": { backgroundColor: "#00796b" },
      }}
    >
      Deposit
    </Button>
      )}

    {/* Export Button & Menu */}
    <div>
      <Button
        variant="contained"
        onClick={handleExportClickd}
        sx={{
          backgroundColor: "#009688",
          fontWeight: "bold",
          color: "#fff",
          "&:hover": { backgroundColor: "#00796b" },
        }}
        startIcon={<PresentToAllIcon />}
      >
        Export
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClosed}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleClosed();
            exportToExcel();
          }}
          sx={{
            color: "#00796b",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#e8f0fe" },
          }}
        >
          <ListItemIcon sx={{ color: "#00796b" }}>
            <SimCardDownloadIcon />
          </ListItemIcon>
          <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
        </MenuItem>

        {/* <MenuItem
          onClick={exportToPDF}
          sx={{
            color: "#d32f2f",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#fdecea" },
          }}
        >
          <ListItemIcon sx={{ color: "#d32f2f" }}>
            <PictureAsPdfIcon />
          </ListItemIcon>
          <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
        </MenuItem> */}
      </Menu>
    </div>
  </div>
</div>


        <div
        ref={tableRef}
        style={{
         height: viewType === "daily" ? "650px" : "250px",
         display: "flex", flexDirection: "column" ,border: "1px solid #004d4d",margin:'10px'}}>

       {/* School name and date */}    
<div
  style={{
    backgroundColor: "#3C3972",
    // color: "#d7f368ff",
    padding: "10px 20px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Left: Logo */}
  {/* <Box display="flex" alignItems="center">
    <img
      src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
      alt="School Logo"
      style={{ width: 80, height: 80 }}
    />
  </Box> */}

    <Box sx={{ width: 100, height: 100 }}>
              <img
                src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                alt="Logo"
                style={{
                  width: "90px",         // Set a single value
                  height:"90px",        // Match the width exactly
                  borderRadius: "50%",    // Ensures circle
                  objectFit: "cover",     // Ensures image fills without distortion
                }}
              />
    </Box>

  {/* Center: School Details */}
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    textAlign="center"
    flex={1}
  >
    <Typography fontWeight="bold" fontSize="23px" sx={{ color: "#FFFFFF" }}>
      {companyInfo.schoolName}
    </Typography>
<Typography fontSize="16px" sx={{ color: "#FFFFFF" }}>
  {capitalizeWords(companyInfo.schoolAddress)}
</Typography>
<Typography fontSize="16px" sx={{ color: "#FFFFFF" }}>
  {capitalizeWords(companyInfo.primaryContact)}
</Typography>
  </Box>

  {/* Right: Generated Date */}
  {/* <Box textAlign="right" whiteSpace="nowrap">
    Generated On: {selectedDate}
  </Box> */}
  {/* <Box textAlign="right" whiteSpace="nowrap"sx={{ color: "#f5e8e8ff" }} >
  Generated On: {new Date().toISOString().slice(0, 10)}
</Box> */}
<Box textAlign="right" whiteSpace="nowrap" sx={{ color: "#f5e8e8ff" }}>
  <div>Generated On: {new Date().toISOString().slice(0, 10)}</div>
  {viewType === "daily" && (
  // <div>
  //   Updated On:{" "}
  //   {totals?.updatedAt
  //     ? new Date(
  //         totals.updatedAt[0],        // year
  //         totals.updatedAt[1] - 1,    // month (0-indexed)
  //         totals.updatedAt[2],        // day
  //         totals.updatedAt[3],        // hour
  //         totals.updatedAt[4],        // minute
  //         totals.updatedAt[5]         // second
  //       ).toLocaleString()
  //     : "-"}
  // </div>
  <div>
  Updated On:{" "}
  {totals?.updatedAt ? (() => {
    const d = new Date(
      totals.updatedAt[0],       // year
      totals.updatedAt[1] - 1,   // month (0-indexed)
      totals.updatedAt[2],       // day
      totals.updatedAt[3],       // hour
      totals.updatedAt[4],       // minute
      totals.updatedAt[5]        // second
    );

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;

    return `${day}/${month}/${year}, ${formattedTime}`;
  })() : "-"}
</div>

)}

</Box>

</div>


         

{/* //opening balance closing balnce amounts */}
<div
  style={{
    margin: "10px",
     marginTop: "15px",
 
    border: "1px solid #004d4d",
    borderRadius: "6px",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
  }}
>
  {/* Header Row */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1.5fr 1.5fr",
      backgroundColor: "#535086ff",
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      // borderBottom: "1px solid #3C3972",
      fontSize: "14px", // smaller text
    }}
  >
    <div style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
      Opening Balance
    </div>
    <div style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
      Collected Amount
    </div>
    <div style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
      Total Amount (Open + Collected - Expenses )
    </div>
     <div style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
      Expenses Amount
    </div>
    <div style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
      Deposit Amount(Only Cash)
    </div>
   
    <div style={{ padding: "8px" }}>Closing Balance (Total - Online - Deposit)</div>
  </div>



  {/* Data Row */}
{viewType === "daily" ? (
  // 🔹 DAILY SUMMARY UI
  <>
  <div style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1.5fr 1.5fr",
    backgroundColor: "#fff",
    textAlign: "center",
    color: "#b71c1c",
    fontWeight: "bold",
    fontSize: "14px",
    borderTop: "1px solid #ccc",
  }}>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.openingBalance || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.todayCollectedAmount || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.totalAmount || "0"}</div>
        <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.expenseAmount || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.todayDepositAmount || "0"}</div>

    <div style={{ padding: "10px" }}>₹{totals.closingBalance || "0"}</div>
  </div>
   {/* 🔹 SECOND ROW FOR ONLINE & OFFLINE AMOUNTS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          backgroundColor: "#f7f7f7",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          borderTop: "1px solid #ccc",
        }}
      >
        <div
  style={{
    padding: "10px",
    borderRight: "1px solid #ccc",
  }}
>
  <span style={{ color: "#3C3972", fontWeight: "bold "}}>Online Amount:</span>{" "}
  <span style={{ color: "#1b5e20", fontWeight: 600 }}>
    ₹{totals.todayTransactionOnline || "0"}
  </span>
</div>

<div
  style={{
    padding: "10px",
    borderRight: "1px solid #ccc",
  }}
>
  <span style={{ color: "#3C3972", fontWeight: "bold" }}>Cash Amount:</span>{" "}
  <span style={{ color: "#1b5e20", fontWeight: 600 }}>
    ₹{totals.todayTransactionCash || "0"}
  </span>
</div>
        {/* <div style={{ padding: "10px", color: "#0d47a1" }}>
          Cash Amount: ₹{totals.todayTransactionCash || "0"}
        </div> */}
      </div>
</>
) : (
  // 🔸 MONTHLY SUMMARY UI
  <>
  <div style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1.5fr 1.5fr",
    backgroundColor: "#fff",
    textAlign: "center",
    color: "#b71c1c",
    fontWeight: "bold",
    fontSize: "14px",
    borderTop: "1px solid #ccc",
  }}>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.openingBalance || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.totalCollected || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.totalAmountOfMonth || "0"}</div>
     <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.totalExpenses || "0"}</div>
    <div style={{ padding: "10px", borderRight: "1px solid #ccc" }}>₹{totals.totalDeposits || "0"}</div>
   
    <div style={{ padding: "10px" }}>₹{totals.closingBalance || "0"}</div>
  </div>
   {/* 🔸 SECOND ROW FOR ONLINE & OFFLINE AMOUNTS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          backgroundColor: "#f7f7f7",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          borderTop: "1px solid #ccc",
        }}
      >
        <div
          style={{
            padding: "10px",
            borderRight: "1px solid #ccc",
            color: "#1b5e20",
          }}
        >
          Online Amount: ₹{totals.todayTransactionOnline || "0"}
        </div>
        <div style={{ padding: "10px", color: "#0d47a1" }}>
          Cash Amount: ₹{totals.todayTransactionCash || "0"}
        </div>
      </div>
    </>
)}


</div>




{/* //STUDENT LIST TABLE */}
       <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

        {/* ✅ Only show table  in Daily View */}
  {viewType === "daily" && (
<div
  style={{
    border: "2px solid #3C3972",
    borderRadius: "4px",
    overflow: "hidden",
   height: sampleRows.length === 0 ? "136.5px" : "380px",
    // width: "100%",
    // minWidth: "950px",
    display: "flex",
    flexDirection: "column",
      margin:'10px'
  }}
>
  {/* Scrollable Table Container */}
  <div
    style={{
      flex: 1,
      overflowY: "auto",
      position: "relative",
     
    }}
     className="custom-sidebar-scrollbar"
  >
  <table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  }}
  className="custom-sidebar-scrollbar"
>
  {/* Header */}
  <thead
    style={{
      position: "sticky",
      top: 0,
      backgroundColor: "#3C3972",
      color: "white",
      zIndex: 2,
    }}
  >
    <tr>
      {[
        "S.No",
        "Admission No",
        "Student Name",
        "Class",
        "Father Name",
        "Receipt No",
        "Receipt Type",
        "Payment Type",
         "Paid Amount",
      ].map((header, i) => (
        <th
          key={i}
          style={{
            padding: "8px 6px",
            borderRight: i !== 8 ? "1px solid #ccc" : "none",
            textAlign: "center",
            // whiteSpace: "nowrap",
            whiteSpace: "normal", // ✅ allows wrapping
            wordWrap: "break-word", // ✅ ensures long text breaks
            fontWeight: "bold",
            backgroundColor: "#535086ff",
          }}
        >
          {header}
        </th>
      ))}
    </tr>
  </thead>

  {/* Body */}
  <tbody>
    {loader ? (
      <tr>
        <td colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Typography variant="body2" sx={{ mt: 1 }}>
              Loading Data...
            </Typography>
          </Box>
        </td>
      </tr>
    ) : sampleRows.length === 0 ? (
      <tr>
        <td colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
          No Payments available
        </td>
      </tr>
    ) : (
     sampleRows.map((r, i) => (
  <tr
    key={i}
    style={{
      backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#fff",
      textAlign: "center",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
    onMouseLeave={(e) =>
      (e.currentTarget.style.backgroundColor = i % 2 === 0 ? "#f9f9f9" : "#fff")
    }
  >
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>{i + 1}</td>
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>{r.admissionNumber}</td>
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>
      {`${r.firstName || ""} ${r.lastName || ""}`.trim()}
    </td>
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>
      {`${r.romanNumberClass || ""} `}
    </td>
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>
      {r.fathersName || "N/A"}
    </td>
    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>{r.receiptNo || 0}</td>

    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>{r.receiptType || 0}</td>

  <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>
  {r.paymentType
    ? r.paymentType
        .replace(/[^a-zA-Z0-9 ]/g, " ") // remove special characters
        .split(" ")                     // split into words
        .filter(Boolean)                // remove empty items
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")                      // join back with space
    : ""}
</td>


    <td style={{ padding: "6px", borderRight: "1px solid #ccc" }}>₹{r.totalPaid || 0}</td>
  </tr>
))

    )}
  </tbody>

  {/* Footer */}
  <tfoot
    style={{
      position: "sticky",
      bottom: 0,
      backgroundColor: "#535086ff",
      color: "white",
      fontWeight: "bold",
      zIndex: 2,
    }}
  >
    <tr>
      <td
        colSpan={8}
        style={{
          textAlign: "center",
          padding: "8px 12px",
          borderRight: "1px solid #ccc",
        }}
      >
        TOTAL AMOUNT
      </td>
      <td style={{ padding: "8px", textAlign: "center" }}>
        ₹
        {sampleRows
          .reduce((sum, row) => sum + (row.totalPaid || 0), 0)
          .toLocaleString("en-IN")}
      </td>
    </tr>
  </tfoot>
</table>


  </div>
</div>
  )}

{/* ✅ DEPOSIT Dialog Box */}
<Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  sx={{
    "& .MuiDialog-paper": {
      width: "600px",
      maxWidth: "90%",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
    },
  }}
>
  <DialogTitle sx={{ fontWeight: "bold", color: "#3C3972", pb: 1,fontSize:'20px' }}>
    Add Deposit Amount
  </DialogTitle>
  {/* Display selected date just under title */}
  <Typography
    variant="subtitle2"
    sx={{
      color: "#555",
      fontWeight: 500,
      ml: 3,
      mt: 0.5,
      mb: 1.5,
    }}
  >
    Deposit Date:{" "}
    <span style={{ color: "#3C3972", fontWeight: 600,fontSize:'15px' }}>
      {selectedDate
        ? new Date(selectedDate).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : "—"}
    </span>
  </Typography>

  <DialogContent sx={{ pt: 1.5 }}>
    {/* Input and Confirmation Box */}
   <Paper
  elevation={0}
  sx={{
    p: 2,
    borderRadius: 2,
    border: "1px solid #e0e0e0",
    backgroundColor: "#fafafa",
  }}
>
  <Box display="flex" flexDirection="column" gap={2}>

   <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#e0e0e0",
    borderRadius: "8px",
    padding: "12px 16px",
    width: "100%",
    maxWidth: "780px",
    color: "#333",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
  }}
>
  {/* Collected Cash */}
  <Box sx={{ textAlign: "center", flex: 1 }}>
    <Typography
      variant="subtitle2"
      sx={{ color: "#555", fontWeight: "bold", mb: 0.5 }}
    >
      Cash(Open+Collected)
    </Typography>
    <Typography sx={{ fontSize: "1rem", fontWeight: "600", color: "#2e7d32" }}>
      ₹{cashSummary.totalTransactionCash || "0"}
    </Typography>
  </Box>

  <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "#999" }} />

  {/* Expenses Cash */}
  <Box sx={{ textAlign: "center", flex: 1 }}>
    <Typography
      variant="subtitle2"
      sx={{ color: "#555", fontWeight: "bold", mb: 0.5 }}
    >
      Expenses Cash
    </Typography>
    <Typography sx={{ fontSize: "1rem", fontWeight: "600", color: "#c62828" }}>
      ₹{cashSummary.totalExpenseCash || "0"}
    </Typography>
  </Box>

  <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "#999" }} />

  {/* Total Cash */}
  <Box sx={{ textAlign: "center", flex: 1 }}>
    <Typography
      variant="subtitle2"
      sx={{ color: "#555", fontWeight: "bold", mb: 0.5 }}
    >
      Total Cash (Collected - Expenses)
    </Typography>
    <Typography sx={{ fontSize: "1rem", fontWeight: "600", color: "#1b5e20" }}>
     ₹{cashSummary.availableInHandCash || "0"}
    </Typography>
  </Box>
</Box>

{Number(deposits?.todayDepositAmount) <= 0 && (
  <>
    {/* Amount Field */}
<TextField
  label="Deposit Amount"
  name="todayDepositAmount"
  placeholder="Enter Amount"
  value={
    isUserEdited
      ? formData.todayDepositAmount
      : cashSummary?.availableInHandCash?.toString() || ""
  }
  onChange={(e) => {
    const value = e.target.value;

    // Allow only numbers and decimals
    if (/^\d*\.?\d*$/.test(value)) {
      setIsUserEdited(true);

      const numericValue = parseFloat(value || "0");
      const maxAmount = parseFloat(cashSummary?.availableInHandCash || "0");

      // Validation
      if (numericValue > maxAmount) {
        setErrors({
          ...errors,
          todayDepositAmount: `Entered amount exceeds available ₹${maxAmount}`,
        });
      } else {
        setErrors({ ...errors, todayDepositAmount: "" });
      }

      setFormData({ ...formData, todayDepositAmount: value });
    }
  }}
  variant="outlined"
  size="small"
  type="text"
  error={!!errors.todayDepositAmount}
  helperText={errors.todayDepositAmount}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontWeight: "bold", fontSize: "0.95rem" }}>
          ₹
        </Typography>
      </InputAdornment>
    ),
  }}
  sx={{ width: "100%", maxWidth: "250px" }}
/>


    {/* Confirmation Checkbox */}
    <FormControlLabel
      control={
        <Checkbox
          checked={formData.confirmDeposit || false}
          onChange={(e) =>
            setFormData({ ...formData, confirmDeposit: e.target.checked })
          }
          color="primary"
        />
      }
      label={
        <Typography sx={{ fontSize: "0.9rem", color: "#444" }}>
          Are you sure you want to deposit this amount?
        </Typography>
      }
    />

    {/* Save Button */}
    <Button
      onClick={handleSave}
      variant="contained"
      // disabled={
      //   loading ||
      //   !formData.todayDepositAmount ||
      //   !formData.confirmDeposit ||
      //   !!errors.todayDepositAmount
      // }
      disabled={
  loading ||
  !(
    isUserEdited
      ? formData.todayDepositAmount
      : cashSummary?.availableInHandCash
  ) ||
  !formData.confirmDeposit ||
  !!errors.todayDepositAmount
}

      
      sx={{
        width: "150px",
        alignSelf: "flex-start",
        py: 1.2,
        backgroundColor:
          loading || !formData.confirmDeposit ? "#9c9c9c" : "#3C3972",
        "&:hover": {
          backgroundColor:
            loading || !formData.confirmDeposit ? "#9c9c9c" : "#2f2b5a",
        },
        transition: "all 0.3s ease",
      }}
    >
      {loading ? <CircularProgress size={22} color="inherit" /> : "Save"}
    </Button>

 </>
)}
  </Box>
</Paper>


    {/* Deposit Display */}
    {!deposits || Number(deposits.todayDepositAmount) <= 0 ? (
      <Paper
        elevation={0}
        sx={{
          mt: 3,
          p: 2,
          borderRadius: 2,
          textAlign: "center",
          fontSize: "0.95rem",
          color: "#777",
          border: "1px dashed #ccc",
        }}
      >
        No deposit amount available.
      </Paper>
    ) : (
      <Paper
        elevation={1}
        sx={{
          mt: 3,
          p: 2.5,
          borderRadius: 2,
          border: "1px solid #ddd",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          "&:hover": { boxShadow: "0 2px 12px rgba(0,0,0,0.08)" },
          transition: "0.3s",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: "#3C3972",
            flex: 1,
            fontSize: "0.95rem",
          }}
        >
          Deposit Amount
        </Typography>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          {deposits.isEditing ? (
            <TextField
              value={deposits.editAmount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setDeposits((prev) => ({ ...prev, editAmount: value }));
                }
              }}
              size="small"
              sx={{ width: "120px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
            />
            
          ) : (
            <Typography sx={{ fontWeight: 500, fontSize: "1rem", color: "#333" }}>
              ₹ {deposits.todayDepositAmount}
            </Typography>
          )}
        </Box>

        {/* {selectedDate === todayDate && ( */}
          <Box sx={{ flex: 1, textAlign: "right" }}>
            {deposits.isEditing ? (
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#3C3972",
                  "&:hover": { backgroundColor: "#3C3972" },
                  fontSize: "0.75rem",
                  minWidth: "70px",
                }}
                onClick={async () => {
                  const updatedAmount = Number(deposits.editAmount);
                  if (updatedAmount <= 0) {
                    toast.error("Enter valid amount");
                    return;
                  }

                  try {
                    

                    const response = await fetch(
                      `${baseUrl}/api/balanceReport/calculate/${pId}?depositAmount=${updatedAmount}&date=${selectedDate}`,
                      { method: "POST" }
                    );

                    if (response.ok) {
                      toast.success("Amount updated!", { autoClose: 1000 });
                      fetchDailySummary();
                    } else {
                      const errorText = await response.text();
                      toast.error(`Failed: ${errorText}`);
                    }
                  } catch (err) {
                    console.error(err);
                    toast.error("Error updating amount");
                  }
                }}
              >
                Save
              </Button>
            ) : (
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#1976d2",
                  "&:hover": { backgroundColor: "#115293" },
                  fontSize: "0.75rem",
                  minWidth: "70px",
                }}
                onClick={() =>
                  setDeposits((prev) => ({
                    ...prev,
                    isEditing: true,
                    editAmount: prev.todayDepositAmount,
                  }))
                }
              >
                Edit
              </Button>
            )}
          </Box>
       
      </Paper>
    )}
  </DialogContent>

  <DialogActions sx={{ pr: 3, pb: 2 }}>
    <Button
      onClick={() => setOpenDialog(false)}
      color="primary"
      variant="outlined"
      sx={{
        borderRadius: "8px",
        textTransform: "none",
      }}
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>


        </div>
      </div>
         <ToastContainer/>
    </div>
  );
}